/**
 * DevExtreme (esm/renovation/ui/common/base_props.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var BaseWidgetProps = {
    className: "",
    activeStateEnabled: false,
    disabled: false,
    focusStateEnabled: false,
    hoverStateEnabled: false,
    tabIndex: 0,
    visible: true
};
